import { apiUrl } from './config';
import type { ScanQuery, ScansResponse } from './types';

/** The token was rejected (HTTP 401): the person must sign in again. */
export class UnauthorizedError extends Error {
  constructor() {
    super('Signed out');
    this.name = 'UnauthorizedError';
  }
}

/** The person is signed in but is not an admin (HTTP 403). */
export class ForbiddenError extends Error {
  constructor() {
    super('Not authorised');
    this.name = 'ForbiddenError';
  }
}

export type FetchScans = (query: ScanQuery, token: string) => Promise<ScansResponse>;

export const fetchScans: FetchScans = async (query, token) => {
  const params = new URLSearchParams({ from: query.from, to: query.to });
  if (query.playerId) params.set('playerId', query.playerId);
  const res = await fetch(`${apiUrl('api/v1/admin/scans')}?${params.toString()}`, {
    headers: { Authorization: `Bearer ${token}` },
  });
  if (res.status === 401) throw new UnauthorizedError();
  if (res.status === 403) throw new ForbiddenError();
  if (!res.ok) {
    let message = `Request failed (${res.status})`;
    try {
      const body = (await res.json()) as { error?: { message?: string } };
      if (body.error?.message) message = body.error.message;
    } catch {
      // keep the generic message
    }
    throw new Error(message);
  }
  return (await res.json()) as ScansResponse;
};
